import React from 'react';
import html2pdf from 'html2pdf.js';

const PrintButton = ({ projectName }) => {

  const printPDF = () => {
    const wbsTable = document.querySelector('#wbsTable');
    const costTable = document.querySelector('#costTable');

    const clonedWbsTable = wbsTable.cloneNode(true);
    const clonedCostTable = costTable.cloneNode(true);

    const container = document.createElement('div');

    // Add the project name at the top of the PDF
    const projectNameHeader = document.createElement('h2');
    projectNameHeader.textContent = `Project: ${projectName}`;  // Format as "Project: projectName"
    projectNameHeader.style.textAlign = 'center';  // Center the project name horizontally
    projectNameHeader.style.marginBottom = '20px';  // Add 20px space below the project name
    container.appendChild(projectNameHeader);

    container.appendChild(clonedWbsTable);

    const spaceDiv = document.createElement('div');
    spaceDiv.style.height = '50px';  // Add space between the tables
    container.appendChild(spaceDiv);

    container.appendChild(clonedCostTable);

    document.body.appendChild(container);

    clonedWbsTable.style.width = '100%';
    clonedCostTable.style.width = '100%';
    clonedCostTable.style.marginTop = '20px';

    const options = {
      margin: 0.5,
      filename: 'Project-Budget.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3, logging: true },
      jsPDF: {
        unit: 'in',
        format: 'letter',
        orientation: 'landscape',
        compress: true,
        pageSize: 'letter',
        putOnlyUsedFonts: true,
        autoPaging: true,
      },
    };

    html2pdf()
      .from(container)
      .set(options)
      .save();

    document.body.removeChild(container);
  };

  return (
    <div>
      <button 
        style={{
            backgroundColor: '#003D7C', 
            color: 'white', 
            border: 'none', 
            borderRadius: '10px', 
            fontSize: 'inherit',
            // fontSize: '14px', 
            padding: '10px 20px'
        }} 
        onClick={printPDF}
      >
        Export as PDF
      </button>
    </div>
  );
};

export default PrintButton;
